import Chip from '@mui/material/Chip'
import { GridCellParams } from '@/global/components/DataGrid/utils/types'
import React from 'react'

function TipoEscala({ value }: GridCellParams) {
    return (
        <Chip
            label={value}
            color="secondary"
            sx={{
                width: 100,
            }}
        />
    )
}

export default TipoEscala
